export type GameMode = 'marvel' | 'powerrangers';

export type Universe = GameMode;

const MODE_KEY = 'avengers-match:current-mode';
const OLD_SW_MODE_VALUE = 'starwars';

let cached: GameMode | null = null;

export function getCurrentMode(): GameMode {
  if (cached) return cached;
  try {
    const raw = localStorage.getItem(MODE_KEY);
    if (raw === 'powerrangers' || raw === 'marvel') {
      cached = raw;
      return raw;
    }
    if (raw === OLD_SW_MODE_VALUE) {
      cached = 'marvel';
      localStorage.setItem(MODE_KEY, 'marvel');
      return 'marvel';
    }
  } catch {}
  cached = 'marvel';
  return 'marvel';
}

export function setCurrentMode(mode: GameMode) {
  cached = mode;
  try {
    localStorage.setItem(MODE_KEY, mode);
  } catch {}
}

export function saveKeyForMode(mode: GameMode): string {
  return mode === 'marvel'
    ? 'avengers-match:save-v1'
    : 'avengers-match:save-pr-v1';
}
